import React, { useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { backendTrackDetail } from "./TrackDetail.dto"; 
import swhTitle from "../../../images/titile.png";
import TopNavBar from "../../../common/Header/TopNavBar";

function Track2Detail() {
  const { id } = useParams();
  const track2d = backendTrackDetail.find((item) => item.id === parseInt(id, 10));

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);

  if (!track2d) {
    return <div>Course not found.</div>;
  }
  return (
    <> 
      <TopNavBar />
      <div className="containerS training p-2 td-container">
          <div className="track2Detail">
            <img src={swhTitle} alt="project" className="mt-5 w-25 img-fluid swhTitle" />
            <h2 className="text-center mt-4 detail-heading">{track2d.title}</h2>
            <div className="row">
              <div className="col-7 p-3 mx-5 text-white">
                <h3 className="m-3">{track2d.name}</h3>
                <p className="mt-4">{track2d.description}</p>
              </div>
              <div className="col-3 mx-5 sticky-html-image">
                <img src={track2d.image} alt="project" className="card-img img-fluid" style={{ height: "200px", width: "300px" }} />
              </div>
            </div>
            <div className="col-10 l-outcome mx-5 p-1 m-5">
              <h3 className="text-center m-3">Learning outcome</h3>
              <ul className="list-unstyled">
                {track2d.learning_outcome.map((outcome, index) => (
                  <li key={index} className="d-flex mt-0">
                    <p style={{ textAlign: 'left' }}>
                      <FaCheck className="fa-solid fa-check mx-2" />
                      {outcome}
                    </p>
                  </li>
                ))}
              </ul>
            </div>

            <h3 className="mx-5 hl">HTML Course Contents</h3>
            <div className="col-8 l-content mx-5 p-1">
              <div className="accordion" id={`courseAccordion`}>
                {track2d.course_contents.map((content, contentIndex) => (
                  <div key={contentIndex} className="accordion-item">
                    <h2 className="accordion-header" id={`heading-${contentIndex}`}>
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${contentIndex}`}
                        aria-expanded="false"
                        aria-controls={`collapse-${contentIndex}`}
                      >
                        {content.topic}
                      </button>
                    </h2>
                    <div
                      id={`collapse-${contentIndex}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading-${contentIndex}`}
                      data-bs-parent={`#courseAccordion`}
                    >
                      <div className="accordion-body">
                        <p>{content.para}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
      </div>
    </>
  );
}

export default Track2Detail;
